/* eslint-disable i18next/no-literal-string -- Aa is a fixed, language-neutral typography specimen. */
import type { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'
import { TEXT_APPEARANCE_PRESETS, TEXT_STYLE_PRESETS, textAppearancePreset, textStylePreset, type TextAppearancePreset } from 'vibe-remotion'
import type { EditSpecTextStyleDict } from '../../../../generated/nodeDataTypes'
import type { TextPatch, TextTrackItem } from './textTrack'
import { TextIcon } from './TextInspectorIcons'

// Glyph sizes are SVG viewBox units, not UI font sizes.
function svgTextStyle(css: CSSProperties): CSSProperties {
  const stroke = String(css.WebkitTextStroke ?? '0px transparent').split(' ')
  const { fontSize: _fontSize, ...decoration } = css
  return { ...decoration, fill: css.color ?? '#FFFFFF', stroke: stroke.slice(1).join(' '), strokeWidth: parseFloat(stroke[0]), paintOrder: 'stroke fill' }
}

export function applyTextAppearance(style: EditSpecTextStyleDict | undefined, id: TextAppearancePreset): EditSpecTextStyleDict {
  const { color: _color, background_color: _background, background_opacity: _opacity, padding: _padding, border_radius: _radius, outline: _outline, shadow: _shadow, ...typography } = style ?? {}
  return { ...typography, appearance_preset: id }
}

export function TextPresetGallery({ item, onChange, legacy = false }: { item: TextTrackItem; onChange: (patch: TextPatch) => void; legacy?: boolean }) {
  const { t } = useTranslation('canvas')
  if (legacy) return <div className="text-preset-grid" data-testid="text-legacy-presets">
    {TEXT_STYLE_PRESETS.map((id) => <button type="button" key={id} className="text-preset-tile" aria-label={t(`textTrack.legacyPresets.${id}`)} aria-pressed={item.style_preset === id && !item.style?.appearance_preset}
      onClick={() => { const { appearance_preset: _appearance, ...style } = applyTextAppearance(item.style, 'none'); onChange({ style_preset: id, style }) }}>
      <svg viewBox="0 0 112 112" aria-hidden="true"><text x="56" y="78" fontSize="60" textAnchor="middle" style={{ ...svgTextStyle(textStylePreset(id)), fontFamily: 'DWTextSans', letterSpacing: 0, textTransform: 'none' }}>Aa</text></svg>
    </button>)}
  </div>
  return <div className="text-preset-grid" data-testid="text-preset-gallery">
    {TEXT_APPEARANCE_PRESETS.map((id) => {
      const css = textAppearancePreset(id)
      const selected = (item.style?.appearance_preset ?? 'none') === id
      return <button type="button" key={id} className="text-preset-tile" data-preset={id} aria-label={t(`textTrack.presets.${id}`)} title={t(`textTrack.presets.${id}`)} aria-pressed={selected}
        onClick={() => onChange({ style: applyTextAppearance(item.style, id) })}>
        {id === 'none' ? <TextIcon name="none" className="text-preset-none" /> : <svg viewBox="0 0 112 112" aria-hidden="true">
          <rect width="112" height="112" rx="20" fill={typeof css.background === 'string' ? css.background : 'transparent'} />
          <text x="56" y="78" fontSize="72" textAnchor="middle" style={{ ...svgTextStyle(css), fontFamily: 'DWTextSans', fontWeight: 800, letterSpacing: -2 }}>Aa</text>
        </svg>}
      </button>
    })}
  </div>
}
